var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddNew1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 155,
    viewBox: "0 0 126 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_6344_32337)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 11.1729,
    width: 100,
    height: 100,
    rx: 50,
    fill: "#636360",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6344_32337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63 33.1729C47.5602 33.1729 35 45.733 35 61.1729C35 76.6127 47.5602 89.1729 63 89.1729C78.4398 89.1729 91 76.6127 91 61.1729C91 45.733 78.4398 33.1729 63 33.1729Z",
    fill: "#9EECF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63 88.6729C47.8363 88.6729 35.5 76.3365 35.5 61.1729C35.5 46.0092 47.8363 33.6729 63 33.6729C78.1637 33.6729 90.5 46.0092 90.5 61.1729C90.5 76.3365 78.1637 88.6729 63 88.6729ZM63 36.1729C49.2139 36.1729 38 47.3868 38 61.1729C38 74.9589 49.2139 86.1729 63 86.1729C76.7861 86.1729 88 74.9589 88 61.1729C88 47.3868 76.7861 36.1729 63 36.1729Z",
    fill: "black",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.25 62.4229H50.75C50.0601 62.4229 49.5 61.8627 49.5 61.1729C49.5 60.483 50.0601 59.9229 50.75 59.9229H75.25C75.9399 59.9229 76.5 60.483 76.5 61.1729C76.5 61.8627 75.9399 62.4229 75.25 62.4229Z",
    fill: "black",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63 74.6729C62.3101 74.6729 61.75 74.1127 61.75 73.4229V48.9229C61.75 48.233 62.3101 47.6729 63 47.6729C63.6899 47.6729 64.25 48.233 64.25 48.9229V73.4229C64.25 74.1127 63.6899 74.6729 63 74.6729Z",
    fill: "black",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 9.67285,
    width: 103,
    height: 103,
    rx: 51.5,
    stroke: "#636360",
    strokeWidth: 3,
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.3885 148.173L45.8285 136.953V148.173H43.7885V133.813H46.1885L53.5685 144.733V133.813H55.6085V148.173H53.3885ZM62.9104 148.373C59.8504 148.373 57.7904 146.153 57.7904 142.813C57.7904 139.673 59.9304 137.373 62.8504 137.373C66.0104 137.373 68.1104 139.933 67.7504 143.373H59.8504C60.0104 145.533 61.0904 146.793 62.8704 146.793C64.3704 146.793 65.4104 145.973 65.7504 144.593H67.7504C67.2304 146.953 65.4104 148.373 62.9104 148.373ZM62.8104 138.893C61.1904 138.893 60.0904 140.053 59.8704 142.033H65.6104C65.5104 140.073 64.4504 138.893 62.8104 138.893ZM78.4237 148.173L76.0237 140.293L73.6037 148.173H71.5637L68.5037 137.573H70.4837L72.6237 145.293L75.0237 137.573H77.0237L79.3837 145.313L81.5237 137.573H83.5237L80.4437 148.173H78.4237Z",
    fill: "#E8E8DB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_6344_32337",
    x: 0,
    y: 0.172852,
    width: 126,
    height: 126,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.909804 0 0 0 0 0.909804 0 0 0 0 0.858824 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6344_32337"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.388235 0 0 0 0 0.388235 0 0 0 0 0.376471 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_6344_32337",
    result: "effect2_dropShadow_6344_32337"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_6344_32337",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6344_32337"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(35 33.1729)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNew1);
export default __webpack_public_path__ + "static/media/add-new1.54815edb42d9e433f19cd602de4b3191.svg";
export { ForwardRef as ReactComponent };